import { coreColors } from '../colors'
import { Theme } from '.'
import { spacing, fontSize, fontWeight, lineHeight, shadows } from '../styles'
import textScale from '../styles/textScale'

const light: Theme = {
    colors: {
        text: {
            primary: coreColors.grey700,
            primaryInverse: coreColors.white50,
            secondary: coreColors.grey500,
            tertiary: coreColors.grey300,
            placeholder: coreColors.grey400,
            disable: coreColors.grey400,
            action: coreColors.blue300,
            actionActive: coreColors.blue500,
            actionInverse: coreColors.white50,
            neutralAction: coreColors.grey500,
            neutralActionActive: coreColors.grey700,
            neutralSelected: coreColors.grey700,
            selected: coreColors.blue300,
            unselected: coreColors.grey400,
            info: coreColors.blue300,
            positive: coreColors.green200,
            warning: coreColors.orange200,
            error: coreColors.red200,
            alert: coreColors.orange600,
        },
        surface: {
            primary: coreColors.white50,
            primaryInverse: coreColors.grey700,
            secondary: coreColors.grey200,
            secondaryInverse: coreColors.grey600,
            tertiary: coreColors.grey100,
            disable: coreColors.grey200,
            disablePastel: coreColors.grey100,
            action: coreColors.blue300,
            actionHover: coreColors.blue200,
            actionPastelActive: coreColors.blue200,
            actionSubPastelActive: coreColors.blue50,
            actionPastelHover: coreColors.blue50,
            actionActive: coreColors.blue500,
            actionInverse: coreColors.white50,
            neutralAction: coreColors.grey500,
            neutralActionHover: coreColors.grey400,
            neutralActionPastelHover: coreColors.grey200,
            neutralActionSubPastelHover: coreColors.grey100,
            neutralActionActive: coreColors.grey700,
            info: coreColors.blue400,
            infoPastel: coreColors.blue50,
            positive: coreColors.green200,
            positivePastel: coreColors.green100,
            warning: coreColors.orange200,
            warningActive: coreColors.orange150,
            warningPastel: coreColors.orange100,
            error: coreColors.red200,
            errorPastel: coreColors.red100,
            alertPastel: coreColors.yellow50,
        },
        divider: {
            primary: coreColors.grey200,
            secondary: coreColors.grey100,
        },
        border: {
            primary: coreColors.grey200,
            secondary: coreColors.blue100,
            tertiary: coreColors.grey100,
            disable: coreColors.grey400,
            action: coreColors.blue300,
            actionFocus: coreColors.blue200,
            actionActive: coreColors.blue500,
            neutralAction: coreColors.grey500,
            neutralActionFocus: coreColors.grey400,
            neutralActionActive: coreColors.grey700,
            error: coreColors.red200,
            warning: coreColors.orange200,
        },
        background: {
            primary: coreColors.grey100,
            secondary: coreColors.white50,
        },
        icon: {
            primary: coreColors.grey700,
            primaryInverse: coreColors.white50,
            secondary: coreColors.grey500,
            tertiary: coreColors.grey300,
            placeholder: coreColors.grey400,
            disable: coreColors.grey400,
            action: coreColors.blue300,
            actionActive: coreColors.blue500,
            actionInverse: coreColors.white50,
            neutralAction: coreColors.grey500,
            neutralActionActive: coreColors.grey700,
            info: coreColors.blue300,
            positive: coreColors.green200,
            warning: coreColors.orange200,
            error: coreColors.red200,
        },
        illustration: {
            primary: coreColors.blue300,
            secondary: coreColors.blue200,
            tertiary: coreColors.blue100,
        },
        indicator: {
            darkOrange: coreColors.orange200,
            lightGrey: coreColors.grey200,
            explosiveGrey: coreColors.grey400,
            black: coreColors.grey700,
            lightBlue: coreColors.blue200,
            skyBlue: coreColors.blue300,
            darkBlue: coreColors.blue500,
            lightYellow: coreColors.yellow100,
            yolkYellow: coreColors.yellow200,
            doneGreen: coreColors.green200,
            darkGreen: coreColors.green300,
            ribbonRed: coreColors.red200,
            cornsilk: coreColors.yellow50,
            irisPurple: coreColors.purple300,
            lavenderPurple: coreColors.purple100,
            whiteSmoke: coreColors.grey100,
        },
    },
    spacing,
    fontSize,
    fontWeight,
    lineHeight,
    shadows,
    textScale,
}

export default light
